<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="header-right">
    <div class="right-top-row">
      <opening-hours></opening-hours>
      <div class="search-button-top-row">
        <router-link
          :to="{ name: ROUTE_NAMES.SEARCH }"
          v-if="$route.name !== 'search'"
        >
          <div class="search-button-wrapper">
            <search-button></search-button>
          </div>
          <div class="search-icon" title="Search for plant or article">
            <search-icon></search-icon>
          </div>
        </router-link>
      </div>
      <div class="is-flex">
        <div style="margin-right: 1rem; display: flex; align-items: center;">
          <lang-switcher></lang-switcher>
        </div>
        <div title="Account" class="account-icon">
          <AccountIcon></AccountIcon>
        </div>
      </div>
    </div>
    <div class="right-bottom-row" v-if="$route.name !== ROUTE_NAMES.SEARCH">
      <div class="is-relative">
        <div
          @click="clearSearch"
          class="clear-icon"
          v-if="search"
          :title="$t('Clear search')"
        >
          <ClearIcon width="24px" height="24px"></ClearIcon>
        </div>
        <div class="field search-field">
          <div class="control">
            <input
              class="input is-primary search-input"
              type="text"
              autocomplete="off"
              @keyup.enter="openSearchPage"
              :placeholder="$t('Search for...')"
              v-model="searchModel"
            />
          </div>
        </div>
      </div>
      <div class="flex-spacer"></div>
      <router-link :to="{ name: ROUTE_NAMES.SEARCH, query: { q: search } }">
        <search-button style="margin-bottom: 0.75rem;"></search-button>
      </router-link>
    </div>
  </div>
</template>
<script>
import AccountIcon from "@images/account_circle-24px.svg";
import SearchButton from "@/components/common/search-button";
import SearchIcon from "@images/search-24px.svg";
import ClearIcon from "@images/clear-24px.svg";
import OpeningHours from "./opening-hours";
import LangSwitcher from "./lang-switcher-simple";
import { mapGetters } from "vuex";
import { ROUTE_NAMES } from "@/routes";

export default {
  data() {
    return {
      searchModel: ""
    };
  },
  props: {
    search: {
      type: String
    }
  },
  components: {
    SearchIcon,
    SearchButton,
    AccountIcon,
    OpeningHours,
    LangSwitcher,
    ClearIcon
  },
  computed: {
    ...mapGetters({ notifications: "notifications/notifications" }),
    ROUTE_NAMES() {
      return ROUTE_NAMES;
    }
  },
  methods: {
    openSearchPage() {
      this.$router.push({
        name: ROUTE_NAMES.SEARCH,
        query: { q: this.search }
      });
    },
    clearSearch() {
      this.searchModel = "";
      this.$emit("update:search", "");
    }
  },
  mounted() {
    this.searchModel = this.search;
  },
  watch: {
    searchModel(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("update:search", newVal);
      }
    },
    search(newVal) {
      this.searchModel = newVal;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../styles/index";
@import "src/styles/clear-icon";

.account-icon {
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    fill: #4a4a4a;
  }
}

.search-input {
  min-width: 300px;
}

.search-icon {
  display: none;
  margin-left: 0.5rem;

  svg {
    width: 24px;
    height: 24px;
    fill: $text;
  }

  @include until-widescreen {
    display: flex;
    align-items: center;
  }
}

.search-button-wrapper {
  display: none;

  @include widescreen {
    display: block;
  }
}
</style>
